import { type QuizQuestion, QuizQuestionType } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { Type } from '@warp-drive/core/types/symbols';

import { RankQuestionEditorComponent } from '../editors/question/rank.gts';
import { ReportingEditorComponent } from '../editors/reporting/reporting.gts';
import { RankResponseEditorComponent } from '../editors/response/rank.gts';
import { RankScoringEditorComponent } from '../editors/scoring/rank.gts';
import type { QuestionManager } from '../types/question-manager.ts';
import { DEFAULT_RESPONSE } from '../types/quiz-responses.ts';

export const RankQuestionManager: QuestionManager = {
  discriminator: (question: QuizQuestion) =>
    question.type === QuizQuestionType.Rank,
  type: QuizQuestionType.Rank,
  icon: 'ph:sort-descending',
  editingIcon: 'ph:sort-descending-fill',
  editingLabel: 'Options',
  label: 'Rank Question',
  questionComponent: RankQuestionEditorComponent,
  scoringComponent: RankScoringEditorComponent,
  responseComponent: RankResponseEditorComponent,
  reportingComponent: ReportingEditorComponent,
  defaultData: {
    rank: {
      [Type]: DataTypeQuiz.QuizQuestionRank,
      options: [],
      min: 1,
      max: 1,
      scoring: 'descending',
      response: DEFAULT_RESPONSE,
      response0: DEFAULT_RESPONSE,
    },
    reporting: {
      [Type]: DataTypeQuiz.QuizReportingQuestion,
      groupName: '',
      questionName: '',
    },
  },
};
